<template>
  <div class="know-page" v-title data-title="卓考网校|考前必刷知识点">
    <header class="g-header-container">
      <c-header title="必刷知识点" />
    </header>
    <main class="g-view-container">
      <section class="course">
        <h4 class="course-title">初级会计职称</h4>
        <template v-for="(item, index) in list1">
          <van-cell
            class="course-item"
            :key="index"
            :title="item.title"
            :url="item.linkUrl"
            clickable
          >
            <i class="iconfont iconzhishiku" slot="icon"></i>
            <span class="btn-enter">点击进入</span>
          </van-cell>
        </template>
      </section>
      <section class="course">
        <h4 class="course-title">中级会计职称</h4>
        <template v-for="(item, index) in list2">
          <van-cell
            class="course-item"
            :key="index"
            :title="item.title"
            :url="item.linkUrl"
            clickable
          >
            <i class="iconfont iconzhishiku" slot="icon"></i>
            <span class="btn-enter">点击进入</span>
          </van-cell>
        </template>
      </section>
    </main>
    <footer class="g-footer-container">
      <c-tabbar />
    </footer>
  </div>
</template>

<script>
  import CHeader from 'components/header';
  import CTabbar from 'components/tabbar';
  import { LIST1, LIST2 } from './config';

  export default {
    name: 'Know',
    components: {
      CHeader,
      CTabbar,
    },
    created() {
      this.list1 = LIST1;
      this.list2 = LIST2;
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.course {
  margin-top: 10px;
  padding: 0 10px;

  &-title {
    font-size: $font-size-l;
    color: #333;
    font-weight: bold;
    line-height: 3;

    &::before {
      content: "";
      margin-right: 10px;
      border-left: 4px solid $theme-color;
    }
  }

  &-item {
    padding: 15px 8px; // 覆盖 van-cell 默认样式
    border-radius: 6px;

    & + & {
      margin-top: 10px;
    }

    .iconzhishiku {
      margin-right: 10px;
      font-size: 30px;
      color: $theme-color;
    }

    .btn-enter {
      padding: 0 5px;
      color: $theme-color;
      line-height: 20px;
      border: 1px solid;
      border-radius: 10px;
    }
  }
}
</style>
